import React, { Component } from 'react';
import AlbumArt from './AlbumArt.js';
import PlayerControls from './PlayerControls.js';

class NowPlaying extends Component {

  render() {
    return (
      <div className="NowPlaying">
        <AlbumArt albumArtUrl={ this.props.track.album_art.small } album={ this.props.track.album } />
        <h1>Now Playing</h1>
        <h2>{ this.props.track.title }</h2>
        <h2>{ this.props.track.artist }</h2>
        <PlayerControls />
      </div>
    );
  }
}

export default NowPlaying;




// WEBPACK FOOTER //
// ./src/NowPlaying.js